var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.342 1.965H3.408c-.728 0-1.318.59-1.318 1.318v14.934c0 .728.59 1.318 1.318 1.318h14.934c.728 0 1.318-.59 1.318-1.318V3.283c0-.728-.59-1.318-1.318-1.318z",
    stroke: "#2C5BFF",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.922 1.965v17.57M2.09 7.692l17.57-.016M2.09 13.614l17.57-.017",
    stroke: "#2C5BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "media/icons/grid-three-6d581c82.svg";
export { SvgGridThree as ReactComponent };